import React from "react";
import InsuranceFlowChecksHeader from "../InsuranceFlowChecksHeader";
import InsuranceFlowCascoChecksContainer from "./InsuranceFlowCascoChecksContainer";
import CascoCrossCheckFlowContainer from ".././cascoChecks/CascoCrossCheckFlowContainer";
import { useTranslation } from "react-i18next";

const CascoFlowChecksContainer = () => {
  const { t } = useTranslation();

  return (
    <>
      <InsuranceFlowChecksHeader title={t("Settings.InsuranceIntegrationChecks.CascoCheck.Title")} />
      <InsuranceFlowCascoChecksContainer />
      <CascoCrossCheckFlowContainer />
    </>
  );
};

CascoFlowChecksContainer.propTypes = {};

export default CascoFlowChecksContainer;
